
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path d="M6 11H18V13H6V11Z" fill="currentColor"></path></svg>';export default svg;
    